import { styled } from "@mui/material/styles";
import { Chip, DocumentIcon } from "@UI";
import { getIconFromType } from "@Utils/tree/getIconFromType";
import React from "react";
const List = styled("div")({
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    gap: "var(--j-sp-1)",
    maxWidth: "100%"
});
export function SentAttachments({ metadata }) {
    const connections = metadata?.connections ?? [];
    const documents = metadata?.documents ?? [];
    if (connections.length === 0 && documents.length === 0) return null;
    return /*#__PURE__*/ React.createElement(List, null, documents.map((document)=>/*#__PURE__*/ React.createElement(Chip, {
            key: document.persisted ? document.id : document.link,
            tone: "filled",
            icon: /*#__PURE__*/ React.createElement(DocumentIcon, {
                size: 12
            })
        }, document.extension ? `${document.filename}.${document.extension}` : document.filename)), connections.map((connection)=>{
        const Icon = getIconFromType(connection.type);
        return /*#__PURE__*/ React.createElement(Chip, {
            key: `${connection.type}-${connection.id}`,
            tone: "filled",
            icon: Icon ? /*#__PURE__*/ React.createElement(Icon, {
                size: 12
            }) : undefined
        }, connection.title);
    }));
}
